import React, { useRef, useState, useEffect, useContext } from "react";
import {
  Typography,
  Box,
  Grid,
  Stack,
  Button,
  Dialog,
  Divider,
  IconButton,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import ReactToPrint from "react-to-print";
import moment from "moment";
// import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
// import CheckBoxOutlineBlankOutlinedIcon from "@mui/icons-material/CheckBoxOutlineBlankOutlined";
import { ToWords } from "to-words";
import { BiMinusCircle } from "react-icons/bi";
// import { useMutation } from "@apollo/client";
//Import from project
import "../../../Style/pagestyle.scss";
import LogoSchool from "../../../Assets/logoSystem.png";
import WingdingImage from "../../../Assets/tacteing.jpg";
// import PaymentInvoice from "./PaymentInvoice";
import { AuthContext } from "../../../Context/AuthContext";
import {
  currencyFormat,
  currencyFormatRiel,
  generateInvoiceNumber,
} from "../../../Function/DynamicFn";
import { sumTwoNumber, minuseTwoNumber } from "../../../Function/DynamicFn";

const toWords = new ToWords({
  localeCode: "en-US",
  converterOptions: {
    currency: false,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
    doNotAddOnly: true,
  },
});

export default function PrintInvoice({ open, handleClose, editData }) {
  // Change Language
  const { t } = useContext(AuthContext);

  // console.log("editData::", editData);

  // =========== Get List Payment Invoice ===============
  const [paymentList, setPaymentList] = useState([]);

  const handleUpdatePayment = () => {
    let submitData = [];
    if (paymentList?.length > 0) {
      paymentList?.map((rowList) => {
        if (
          rowList?.paymentMethod !== "" &&
          rowList?.paymentMethod !== undefined
        ) {
          submitData.push({
            Khmer: parseFloat(rowList?.Khmer),
            bankAccount: rowList?.bankAccount,
            dollar: parseFloat(rowList?.dollar),
            paymentMethod: rowList?.paymentMethod,
            remark: rowList?.remark,
          });
        }
      });
    }

    if (submitData?.length > 0) {
      // updateInvoicePayment({
      //     variables: {
      //         input: {
      //             invoiceId: editData?._id,
      //             paymentList: submitData,
      //         }
      //     }
      // })
    }
  };

  //
  //   const handleCheckTick = (val) => {
  //     let filterVal = paymentList?.filter((i) => i?.paymentMethod === val);
  //     return filterVal?.length > 0;
  //   };

  //   const handleReturnTextBank = (val) => {
  //     let filterVal = paymentList?.filter((i) => i?.paymentMethod === val);

  //     if (filterVal?.length > 0) {
  //       let string = "";
  //       filterVal?.map((row) => {
  //         string += row?.bankAccount;
  //       });
  //       return string;
  //     } else {
  //       return "";
  //     }
  //   };

  //   const handleReturnCash = (val) => {
  //     let filterVal = paymentList?.filter((i) => i?.paymentMethod === val);
  //     //
  //     if (filterVal?.length > 0) {
  //       let dollar = 0;
  //       let Khmer = 0;
  //       filterVal?.map((row) => {
  //         dollar += parseFloat(row?.dollar);
  //         Khmer += parseFloat(row?.Khmer);
  //       });

  //       if (dollar > 0 && Khmer > 0) {
  //         return currencyFormatRiel(Khmer) + " ៛ & $ " + currencyFormat(dollar);
  //       } else if (dollar > 0 && Khmer === 0) {
  //         return "$ " + currencyFormat(dollar);
  //       } else if (dollar === 0 && Khmer > 0) {
  //         return currencyFormatRiel(Khmer) + " ៛";
  //       } else {
  //         return "";
  //       }
  //     } else {
  //       return "";
  //     }
  //   };

  // const handleReturnTextRemark = () => {
  //   if (editData?.items?.length > 0) {
  //     let string = "";
  //     editData?.items?.map((row) => {
  //       string += row?.remark;
  //     });
  //     return string;
  //   } else {
  //     return "";
  //   }
  // };

  // print
  const componentRef = useRef();
  const reactToPrintContent = () => {
    // if (componentRef.current) {
    //   handleUpdatePayment();
    // }
    return componentRef.current;
  };

  const reactToPrintTrigger = () => {
    return (
      <Button
        sx={{
          width: "30%",
          padding: "6px",
          borderRadius: "10px",
          color: "white",
          backgroundColor: "#0f81c2 !important",
        }}
      >
        Print
      </Button>
    );
  };

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="md">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              {t("modal_title_view_invoice")}
            </Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Box sx={{ marginTop: "10px" }}>
          <Grid container>
            <Grid item xs={3}>
              <Stack direction={"row"} justifyContent={"center"}>
                <img
                  src={LogoSchool}
                  alt="logo"
                  style={{ width: "130px", marginTop: "50px" }}
                />
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{ fontSize: "14px", fontFamily: "KhmerOsMuol" }}
                  align="center"
                >
                  ព្រះរាជាណាចក្រកម្ពុជា
                </Typography>
                <Typography
                  sx={{ fontSize: "14px", fontFamily: "GothicBoldRegular" }}
                  align="center"
                >
                  Kingdom Of Cambodia
                </Typography>
                <Typography
                  sx={{ fontSize: "14px", fontFamily: "KhmerOsMuol" }}
                  align="center"
                >
                  ជាតិ​ សាសនា ព្រះមហាក្សត្រ
                </Typography>
                <Typography
                  sx={{ fontSize: "14px", fontFamily: "GothicBoldRegular" }}
                  align="center"
                >
                  Nation Religions King
                </Typography>
                <Stack direction="row" justifyContent="center">
                  <img
                    alt="Image"
                    src={WingdingImage}
                    className="print-invoice-tackteng"
                  />
                </Stack>
              </Box>
            </Grid>
          </Grid>

          <Box sx={{ marginTop: "20px" }}>
            <Grid container>
              <Grid item xs={4}>
                <Stack direction="column" spacing={0.5}>
                  <Stack direction="row" spacing={0.5}>
                    <Typography
                      sx={{
                        fontFamily: "Siemreap",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      ឈ្មោះសហគ្រាស :
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Siemreap",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      សាលាតន្ត្រីខេត្តសៀមរាប
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={0.5}>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      អាសយដ្ឋាន៖
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      ភូមិមណ្ឌល៣ សង្កាត់ស្លក្រាម
                    </Typography>
                  </Stack>
                  <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }}>
                    ក្រុងសៀមរាប ខេត្តសៀមរាប
                  </Typography>
                  <Stack direction="row" spacing={0.5}>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      Tel :
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      070 712 096
                    </Typography>
                  </Stack>
                  {/* <Stack direction="row" spacing={0.5}>
                    <Typography
                      sx={{
                        fontFamily: "Siemreap",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      VATTIN :
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      B116-901504283
                    </Typography>
                  </Stack> */}
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack direction="column" spacing={0.5}>
                  <Typography
                    sx={{ fontFamily: "Bayon", fontSize: "14px" }}
                    align="center"
                  >
                    <u>វិក្កយបត្រ</u>
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Baloopaaji",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                    align="center"
                  >
                    Invoice
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack direction="column" spacing={0.5}>
                  <Stack direction="row" spacing={0.5}>
                    <Typography
                      sx={{
                        fontFamily: "Siemreap",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      N° :
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      {generateInvoiceNumber(
                        editData?.invoiceNumber,
                        editData?.createdAt
                      )}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={0.5}>
                    <Typography
                      sx={{
                        fontFamily: "Siemreap",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      Bill To :
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      {editData?.studentId?.familyName +
                        " " +
                        editData?.studentId?.studentName}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={0.5}>
                    <Typography
                      sx={{
                        fontFamily: "Siemreap",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      Payment Date :
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      {moment(editData?.createdAt).format(
                        "DD-MMM-YYYY hh:mm a"
                      )}
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ marginTop: "15px" }}>
            <Typography
              sx={{
                fontFamily: "Siemreap",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              ព័ត៌មានសិស្ស/Student Information
            </Typography>
            <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
            <Grid container>
              <Grid item xs={6}>
                <Stack
                  spacing={0.5}
                  direction="column"
                  sx={{ marginTop: "4px" }}
                >
                  <Stack direction="row" spacing={0.5}>
                    <Typography
                      sx={{
                        fontFamily: "Siemreap",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      ឈ្មោះជាភាសាខ្មែរ/Full Name :
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      {editData?.studentId?.familyName +
                        " " +
                        editData?.studentId?.studentName}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={0.5}>
                    <Typography
                      sx={{
                        fontFamily: "Siemreap",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      អត្តលេខ/Khmer ID :
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      {editData?.studentId?.studentId}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={0.5}>
                    <Typography
                      sx={{
                        fontFamily: "Siemreap",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      ភេទ/gender :
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      {editData?.studentId?.gender === "Male"
                        ? t("thead_male")
                        : t("thead_female")}
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
              <Grid item xs={6}>
                <Stack
                  spacing={0.5}
                  direction="column"
                  sx={{ marginTop: "4px" }}
                >
                  <Stack direction="row" spacing={0.5}>
                    <Typography
                      sx={{
                        fontFamily: "Siemreap",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      ថ្ងៃខែឆ្នាំកំណើត/Date of Birth :
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      {moment(editData?.studentId?.dob).format("DD-MMM-YYYY")}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={0.5}>
                    <Typography
                      sx={{
                        fontFamily: "Siemreap",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      លេខទូរស័ព្ទ/Tel :
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      {editData?.studentId?.phoneNumber}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={0.5}>
                    <Typography
                      sx={{
                        fontFamily: "Siemreap",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      ថ្នាក់/Class :
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      {editData?.enrollmentId?.classId?.courseId?.khName
                        ? editData?.enrollmentId?.classId?.courseId?.khName +
                          " " +
                          editData?.enrollmentId?.classId?.className
                        : ""}
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
            <Box sx={{ marginTop: "15px" }}>
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                ការបង់ថ្លៃ/Payment
              </Typography>
              <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
            </Box>
          </Box>
          <table className="print-invoice-table1">
            <tr>
              <th style={{ width: "4%" }} align="left">
                <div>ល.រ</div>
                <div>N⁰</div>
              </th>
              <th style={{ width: "24%" }} align="left">
                <div>បង់ថ្លៃ</div>
                <div>Pay To</div>
              </th>
              <th style={{ width: "13%" }} align="left">
                <div>ចាប់ទី</div>
                <div>Start Date</div>
              </th>
              <th style={{ width: "13%" }} align="left">
                <div>រហូតដល់</div>
                <div>End Date</div>
              </th>
              <th style={{ width: "12%" }} align="right">
                <div>តម្លៃ</div>
                <div>Price</div>
              </th>
              <th style={{ width: "5%" }} align="right">
                <div>ចំនួន</div>
                <div>Qty</div>
              </th>
              <th style={{ width: "12%" }} align="right">
                <div>បញ្ចុះតម្លៃ</div>
                <div>Discount</div>
              </th>
              <th style={{ width: "15%" }} align="right">
                <div>សរុប</div>
                <div>Total Amount</div>
              </th>
            </tr>

            {editData?.items?.map((row, index) => {
              // console.log("row::", row);
              return (
                <tr key={index}>
                  <td align="left">{index + 1}</td>
                  <td align="left">{row?.groupFeeId?.title}</td>
                  {/* <td align="left"></td> */}
                  <td align="left">
                    {row?.startDate
                      ? moment(row?.startDate).format("DD-MM-YYYY")
                      : ""}
                  </td>
                  <td align="left">
                    {row?.endDate
                      ? moment(row?.endDate).format("DD-MM-YYYY")
                      : ""}
                  </td>
                  <td align="right">
                    $ {currencyFormat(parseFloat(row?.price))}
                  </td>
                  <td align="right">{parseFloat(row?.qty)}</td>
                  <td align="right">
                    {row?.discountType === "amount" ? "$" : ""}{" "}
                    {row?.discountType === "amount"
                      ? currencyFormat(parseFloat(row?.discount))
                      : row?.discount}{" "}
                    {row?.discountType === "percentage" ? "%" : ""}{" "}
                  </td>
                  <td align="right">
                    $ {currencyFormat(parseFloat(row?.amount))}
                  </td>
                </tr>
              );
            })}
          </table>

          <Box>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ padding: "4px" }}
            >
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                សរុប (ដុល្លារ)/Total Amount ($) :
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                }}
              >
                $ {currencyFormat(parseFloat(editData?.totalAmount))}
              </Typography>
            </Stack>
            <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
          </Box>
          <Box>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ padding: "4px" }}
            >
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                ទទួល (ដុល្លារ)/Receive Amount ($) :
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                }}
              >
                ${" "}
                {/* {currencyFormat(
                  parseFloat(editData?.totalAmount - editData?.totalOwe)
                )} */}
                {currencyFormat(
                  minuseTwoNumber(editData?.totalAmount, editData?.totalOwe)
                )}
              </Typography>
            </Stack>
            <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
          </Box>
          <Box>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ padding: "4px" }}
            >
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                ជំពាក់ (ដុល្លារ)/Owe Amount ($) :
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                }}
              >
                $ {currencyFormat(parseFloat(editData?.totalOwe))}
              </Typography>
            </Stack>
            <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
          </Box>
          <Box>
            <Stack direction="row" spacing={0.4} sx={{ padding: "4px" }}>
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                ចំនួនទឹកប្រាក់ជាអក្សរ (ដុល្លារ)/Amount In Letter ($) :
              </Typography>
              <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }}>
                {toWords.convert(parseFloat(editData?.totalAmount))} Dollar Only
              </Typography>
            </Stack>
            <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
          </Box>

          <Box>
            <Stack direction="row" sx={{ padding: "4px" }} spacing={1}>
              <Stack direction="column" justifyContent="center">
                <Typography
                  sx={{
                    fontFamily: "Siemreap",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  សម្គាល់​/Note៖
                </Typography>
              </Stack>
              <Stack direction="column" justifyContent="center">
                <Typography
                  sx={{
                    fontFamily: "Siemreap",
                    fontSize: "12px",
                  }}
                >
                  {/* {handleReturnTextRemark()} */}
                  {editData?.remark}
                </Typography>
              </Stack>
            </Stack>
          </Box>

          <Box sx={{ marginTop: "50px" }}>
            <Grid container spacing={3}>
              <Grid item xs={4}>
                <Box sx={{ border: "3px double #000", padding: "8px" }}>
                  <Typography
                    sx={{
                      fontFamily: "Bayon",
                      fontSize: "12px",
                      textAlign: "center",
                    }}
                  >
                    ប្រាក់បង់រូចមិនអាចដក ផ្ទេរ និងរក្សាទុកបានទេ
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Siemreap",
                      fontSize: "12px",
                      textAlign: "center",
                    }}
                  >
                    All processed payments will not be refunded, transfered, or
                    kept.
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Stack
                  direction="column"
                  spacing={0.2}
                  sx={{ marginTop: "20px" }}
                >
                  <Divider sx={{ borderBottom: "1px solid #000" }} />
                  <Stack direction="row" spacing={0.2}>
                    <Typography sx={{ fontFamily: "Bayon", fontSize: "12px" }}>
                      អ្នកបង់ប្រាក់
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      (Payer)
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack
                  direction="column"
                  spacing={0.2}
                  sx={{ marginTop: "20px" }}
                >
                  <Divider sx={{ borderBottom: "1px solid #000" }} />
                  <Stack direction="row" spacing={0.2}>
                    <Typography sx={{ fontFamily: "Bayon", fontSize: "12px" }}>
                      បេឡាធិការ
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      (Cashier)
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </Box>

        {/* ============================================ code to print =============================================== */}
        <Box sx={{ display: "none" }}>
          <Box className="print-invoice-container" ref={componentRef}>
            <Box sx={{ marginTop: "10px" }}>
              <Grid container>
                <Grid item xs={3}>
                  <Stack direction={"row"} justifyContent={"center"}>
                    <img
                      src={LogoSchool}
                      alt="logo"
                      style={{ width: "80px", marginTop: "32px" }}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <Typography className="print-invoice-title-kh">
                      ព្រះរាជាណាចក្រកម្ពុជា
                    </Typography>
                    <Typography className="print-invoice-title-en">
                      Kingdom Of Cambodia
                    </Typography>
                    <Typography className="print-invoice-title-kh">
                      ជាតិ​ សាសនា ព្រះមហាក្សត្រ
                    </Typography>
                    <Typography className="print-invoice-title-en">
                      Nation Religions King
                    </Typography>
                    <Stack direction="row" justifyContent="center">
                      <img
                        alt="Image"
                        src={WingdingImage}
                        className="print-invoice-tackteng"
                      />
                    </Stack>
                  </Box>
                </Grid>
              </Grid>

              <Box sx={{ marginTop: "20px" }}>
                <Grid container>
                  <Grid item xs={4}>
                    <Stack direction="column" spacing={0.5}>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          ឈ្មោះសហគ្រាស :
                        </Typography>
                        <Typography className="print-invoice-header-title-bold">
                          សាលាតន្ត្រីខេត្តសៀមរាប
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title">
                          អាសយដ្ឋាន៖
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          ភូមិមណ្ឌល៣ សង្កាត់ស្លក្រាម
                        </Typography>
                      </Stack>
                      <Typography className="print-invoice-header-title">
                        ក្រុងសៀមរាប ខេត្តសៀមរាប
                      </Typography>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title">
                          Tel :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          070 712 096
                        </Typography>
                      </Stack>
                      {/* <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          VATTIN :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          B116-901504283
                        </Typography>
                      </Stack> */}
                    </Stack>
                  </Grid>
                  <Grid item xs={4}>
                    <Stack direction="column">
                      <Typography className="print-invoice-header-center-title-kh">
                        វិក្កយបត្រ
                      </Typography>
                      <Typography className="print-invoice-header-center-title">
                        Invoice
                      </Typography>
                    </Stack>
                  </Grid>

                  <Grid item xs={4}>
                    <Stack direction="column" spacing={0.5}>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          N° :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {generateInvoiceNumber(
                            editData?.invoiceNumber,
                            editData?.createdAt
                          )}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          Bill To :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {editData?.studentId?.familyName +
                            " " +
                            editData?.studentId?.studentName}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          Payment Date :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {moment(editData?.createdAt).format(
                            "DD-MMM-YYYY hh:mm a"
                          )}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
              </Box>

              <Box sx={{ marginTop: "15px" }}>
                <Typography className="print-invoice-header-title-bold">
                  ព័ត៌មានសិស្ស/Student Information
                </Typography>
                <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
                <Grid container>
                  <Grid item xs={6}>
                    <Stack
                      direction="column"
                      sx={{ marginTop: "4px" }}
                      spacing={0.5}
                    >
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          ឈ្មោះជាភាសាខ្មែរ/Full Name :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {editData?.studentId?.familyName +
                            " " +
                            editData?.studentId?.studentName}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          អត្តលេខ/Khmer ID :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {editData?.studentId?.studentId}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          ភេទ/gender :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {editData?.studentId?.gender === "Male"
                            ? t("thead_male")
                            : t("thead_female")}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                  <Grid item xs={6}>
                    <Stack
                      direction="column"
                      sx={{ marginTop: "4px" }}
                      spacing={0.5}
                    >
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          ថ្ងៃខែឆ្នាំកំណើត/Date of Birth :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {moment(editData?.studentId?.dob).format(
                            "DD-MMM-YYYY"
                          )}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          លេខទូរស័ព្ទ/Tel :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {editData?.studentId?.phoneNumber}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          ថ្នាក់/Class :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {editData?.enrollmentId?.classId?.courseId?.khName
                            ? editData?.enrollmentId?.classId?.courseId
                                ?.khName +
                              " " +
                              editData?.enrollmentId?.classId?.className
                            : ""}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
              </Box>

              <Box sx={{ marginTop: "15px" }}>
                <Typography className="print-invoice-header-title-bold">
                  ការបង់ថ្លៃ/Payment
                </Typography>
                <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
              </Box>
            </Box>

            <table className="print-invoice-table">
              <tr>
                <th style={{ width: "4%" }} align="left">
                  <div>ល.រ</div>
                  <div>N⁰</div>
                </th>
                <th style={{ width: "24%" }} align="left">
                  <div>បង់ថ្លៃ</div>
                  <div>Pay To</div>
                </th>
                <th style={{ width: "13%" }} align="left">
                  <div>ចាប់ទី</div>
                  <div>Start Date</div>
                </th>
                <th style={{ width: "13%" }} align="left">
                  <div>រហូតដល់</div>
                  <div>End Date</div>
                </th>
                <th style={{ width: "12%" }} align="right">
                  <div>តម្លៃ</div>
                  <div>Price</div>
                </th>
                <th style={{ width: "5%" }} align="right">
                  <div>ចំនួន</div>
                  <div>Qty</div>
                </th>
                <th style={{ width: "12%" }} align="right">
                  <div>បញ្ចុះតម្លៃ</div>
                  <div>Discount</div>
                </th>
                <th style={{ width: "15%" }} align="right">
                  <div>សរុប</div>
                  <div>Total Amount</div>
                </th>
              </tr>

              {editData?.items?.map((row, index) => {
                return (
                  <tr key={index}>
                    <td align="left">{index + 1}</td>
                    <td align="left">{row?.groupFeeId?.title}</td>
                    {/* <td align="left"></td> */}
                    <td align="left">
                      {row?.startDate
                        ? moment(row?.startDate).format("DD-MM-YYYY")
                        : ""}
                    </td>
                    <td align="left">
                      {row?.endDate
                        ? moment(row?.endDate).format("DD-MM-YYYY")
                        : ""}
                    </td>
                    <td align="right">
                      $ {currencyFormat(parseFloat(row?.price))}
                    </td>
                    <td align="right">{row?.qty}</td>
                    <td align="right">
                      {row?.discountType === "amount" ? "$" : ""}{" "}
                      {row?.discountType === "amount"
                        ? currencyFormat(parseFloat(row?.discount))
                        : row?.discount}{" "}
                      {row?.discountType === "percentage" ? "%" : ""}{" "}
                    </td>
                    <td align="right">
                      $ {currencyFormat(parseFloat(row?.amount))}
                    </td>
                  </tr>
                );
              })}
            </table>

            <Box>
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ padding: "4px" }}
              >
                <Typography className="print-invoice-header-title-bold">
                  សរុប (ដុល្លារ)/Total Amount ($) :
                </Typography>
                <Typography className="print-invoice-header-title">
                  $ {currencyFormat(parseFloat(editData?.totalAmount))}
                </Typography>
              </Stack>
              <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
            </Box>
            <Box>
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ padding: "4px" }}
              >
                <Typography className="print-invoice-header-title-bold">
                  ទទួល (ដុល្លារ)/Receive Amount ($) :
                </Typography>
                <Typography className="print-invoice-header-title">
                  ${" "}
                  {currencyFormat(
                    minuseTwoNumber(editData?.totalAmount, editData?.totalOwe)
                  )}
                </Typography>
              </Stack>
              <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
            </Box>
            <Box>
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ padding: "4px" }}
              >
                <Typography className="print-invoice-header-title-bold">
                  ជំពាក់ (ដុល្លារ)/Owe Amount ($) :
                </Typography>
                <Typography className="print-invoice-header-title">
                  $ {currencyFormat(parseFloat(editData?.totalOwe))}
                </Typography>
              </Stack>
              <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
            </Box>
            <Box>
              <Stack direction="row" spacing={0.4} sx={{ padding: "4px" }}>
                <Typography className="print-invoice-header-title-bold">
                  ចំនួនទឹកប្រាក់ជាអក្សរ (ដុល្លារ)/Amount In Letter ($) :
                </Typography>
                <Typography className="print-invoice-header-title">
                  {toWords.convert(parseFloat(editData?.totalAmount))} Dollar
                  Only
                </Typography>
              </Stack>
              <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
            </Box>

            <Box>
              <Stack direction="row" sx={{ padding: "4px" }} spacing={1}>
                <Stack direction="column" justifyContent="center">
                  <Typography className="print-invoice-header-title-bold">
                    សម្គាល់​/Note៖
                  </Typography>
                </Stack>
                <Stack direction="column" justifyContent="center">
                  <Typography className="print-invoice-header-title">
                    {/* {handleReturnTextRemark()} */}
                    {editData?.remark}
                  </Typography>
                </Stack>
              </Stack>
            </Box>

            <Box sx={{ marginTop: "50px" }}>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <Box className="print-invoice-box-bottom">
                    <Typography
                      className="print-invoice-footer-kh"
                      sx={{ textAlign: "center" }}
                    >
                      ប្រាក់បង់រូចមិនអាចដក ផ្ទេរ និងរក្សាទុកបានទេ
                    </Typography>
                    <Typography
                      className="print-invoice-footer-en"
                      sx={{ textAlign: "center" }}
                    >
                      All processed payments will not be refunded, transfered,
                      or kept.
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Stack
                    direction="column"
                    spacing={0.2}
                    sx={{ marginTop: "18px" }}
                  >
                    <Divider sx={{ borderBottom: "1px solid #000" }} />
                    <Stack direction="row" spacing={0.2}>
                      <Typography className="print-invoice-footer-kh">
                        អ្នកបង់ប្រាក់
                      </Typography>
                      <Typography className="print-invoice-footer-en">
                        (Payer)
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={4}>
                  <Stack
                    direction="column"
                    spacing={0.2}
                    sx={{ marginTop: "18px" }}
                  >
                    <Divider sx={{ borderBottom: "1px solid #000" }} />
                    <Stack direction="row" spacing={0.2}>
                      <Typography className="print-invoice-footer-kh">
                        បេឡាធិការ
                      </Typography>
                      <Typography className="print-invoice-footer-en">
                        (Cashier)
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>

        <Stack direction="row" justifyContent="right">
          <ReactToPrint
            removeAfterPrint
            content={reactToPrintContent}
            trigger={reactToPrintTrigger}
            documentTitle={`${editData?.studentId?.fullName}-invoice`}
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
